import React, { useEffect, useRef, useState } from 'react';
import { formatToZMW, handlePrint, rootUrl, handleExcel } from '../../../helpers';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';
import { useAuth } from '../../../context/auth-context';
import { toast } from 'react-toastify';
import FormGenerator from '../../../components/formGenerator';
import { FaFolderOpen, FaPrint, FaFileExcel } from 'react-icons/fa';
import BudgetForm from './form';

export default function SupplierStatement({ id, name }){
    const [data, setData] = useState([]); 
    const [balance, setBalance] = useState(0.0); 
    const [loading, setLoading] = useState(false); 
    const [error, setError] = useState(null); 
    const [makePayment, setMakePayment] = useState(false);
    const [projects, setProjects] = useState([]);

    useEffect(()=>{
        fetchData()
        axios.get(rootUrl(`/getProjs`))
        .then(response => {  
          setProjects(response.data.data); 
        })
        .catch(error => {
            setError('Error fetching data');
            console.error(error);
        })
    }, [])


    const auth = useAuth();
    const {allData, setAllData} = useOutletContext();


    const fetchData = () => {
        setLoading(true); 
        setError(null); 
        axios.get(rootUrl(`/suppliertrans/${id}`))
            .then(response => {  
                setData(response.data.suppliers); 
            })
            .catch(error => {
                setError('Error fetching data');
                console.error(error);
            })
            .finally(() => setLoading(false)); // Stop loading
    };

      const onSubmitForm = async (formData) => {
        formData['uid'] = auth.user.id
        formData['sid'] = id
        try{
          const response = await axios.post(rootUrl('/addSupPayment'), formData)
          if(response.data.status === 200){
            toast.success("Submitted successfully")
            setMakePayment(false)
          }else{
            toast.error("Something went wrong")
          }
    
        }catch(e){
          toast.error(e?.message)
        }
      }
      const componentRef = useRef(null)

    return (
        <div>
            {loading && <p>Loading...</p>} {/* Loading indicator */}
            {error && <p className="text-red-500">{error}</p>} {/* Error message */}
            
            {data.length === 0 ? (
                <div className="flex flex-col justify-center items-center">
                                                  <FaFolderOpen className="text-gray-500 text-6xl mb-2" />
                                                  <p className="text-gray-600">No data available</p>
                                                </div>
            ) : (
                <>

                     <button
                                                    onClick={() => handlePrint(componentRef)}
                                                    className="bg-blue-950 text-white px-4 py-2 rounded float-right ml-2"
                                                  >
                                                    <FaPrint/>
                                                  </button>
                      <button
                        onClick={() => handleExcel(componentRef, `SupplierStatement`)}
                        className="bg-blue-950 text-white px-4 py-2 rounded float-right ml-2"
                      >
                        <FaFileExcel/>
                        
                      </button>
                <div ref={componentRef} className='border rounded p-4 m-4'>

                <div className='flex flex-col items-center text-center gap-2'>
                            <img className='w-[200px] mx-auto' src={rootUrl(`/${allData?.council[0]?.path}`)} alt="Council Logo" />
                            <h2 className='font-bold text-2xl'>{allData?.council[0]?.name}</h2>
                            <h3 className='font-bold text-lg'>Supplier Statement Of Account</h3>
                </div>
                            <hr className='my-3' />
                    <p className="text-lg font-semibold text-center text-gray-600 p-2 m-2">{name}</p>
                    <table className="min-w-full border border-gray-300 p-2 m-2">
  <thead>
    <tr className="text-left bg-blue-950 text-white">
      <th className="border-b px-4 py-2">Date</th>
      <th className="border-b px-4 py-2">Invoice #</th>
      <th className="border-b px-4 py-2">Description</th>
      <th className="border-b px-4 py-2">Debit</th>
      <th className="border-b px-4 py-2">Credit</th>
      <th className="border-b px-4 py-2">Balance</th>
    </tr>
  </thead>
  <tbody>
    {(() => {
      let runningBalance = 0; // Initialize the running balance
      let totalDebit = 0;
      let totalCredit = 0;

      const rows = data.map((res, index) => {
        if (
          (allData.budget.find(a => a.id === res.coa)?.coa == "321040" ||
            allData.budget.find(a => a.id === res.coa)?.coa == "321040") &&
          res.type == 1
        ) {
          return null;
        }

        const debit = res.type == 1 ? parseFloat(res.amount) : 0;
        const credit = res.type == 2 ? parseFloat(res.amount) : 0;

        // Update totals
        totalDebit += debit;
        totalCredit += credit;
        runningBalance += debit - credit;

        return (
          <tr key={index}>
            <td className="border-b px-4 py-2">{res.date.substring(0, 10)}</td>
            <td className="border-b px-4 py-2">
              {res.invoice != null ? res?.invoice : res?.receipt_no}
            </td>
            <td className="border-b px-4 py-2">{res.comment}</td>
            <td className="border-b px-4 py-2">{formatToZMW(debit)}</td>
            <td className="border-b px-4 py-2">{formatToZMW(credit)}</td>
            <td className="border-b px-4 py-2">{formatToZMW(runningBalance)}</td>
          </tr>
        );
      });

      return (
        <>
          {rows}
          {/* Totals Row */}
          <tr className="bg-gray-200 font-bold">
            <td className="border-t px-4 py-2 text-right" colSpan="3">Total</td>
            <td className="border-t px-4 py-2">{formatToZMW(totalDebit)}</td>
            <td className="border-t px-4 py-2">{formatToZMW(totalCredit)}</td>
            <td className="border-t px-4 py-2">{formatToZMW(runningBalance)}</td>
          </tr>
        </>
      );
    })()}
  </tbody>
</table>


<br/>
</div>
<button className="border rounded p-2 my-2 bg-blue-950 text-white m-4" onClick={()=>setMakePayment(!makePayment)}>Add Payment</button>
                </>
            )}


  {
            makePayment?
            <><span className="font-bold text-lg m-4">Make Payment</span>
            <hr className="mb-3" />
            <div className='m-2 p-2'>
            <BudgetForm data={data} allData={allData} onSubmitForm={onSubmitForm} />
            </div>
               </>
            :
            <></>
          }

        </div>
    );
};



